/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/agent_spa/__root'
import { Route as AgentRouteImport } from './routes/agent_spa/agent'
import { Route as AdminRouteImport } from './routes/agent_spa/admin'
import { Route as AgentIndexRouteImport } from './routes/agent_spa/agent/index'
import { Route as AgentJob_post_tagsRouteImport } from './routes/agent_spa/agent/job_post_tags'
import { Route as AgentCustomizeRouteImport } from './routes/agent_spa/agent/customize'
import { Route as AgentCompany_tagsRouteImport } from './routes/agent_spa/agent/company_tags'
import { Route as AgentCandidate_tagsRouteImport } from './routes/agent_spa/agent/candidate_tags'
import { Route as AgentAnalysisRouteImport } from './routes/agent_spa/agent/analysis'
import { Route as AccountTrialRouteImport } from './routes/agent_spa/account/trial'
import { Route as AccountLoginRouteImport } from './routes/agent_spa/account/login'
import { Route as AgentShared_job_postsIndexRouteImport } from './routes/agent_spa/agent/shared_job_posts/index'
import { Route as AgentSettingsIndexRouteImport } from './routes/agent_spa/agent/settings/index'
import { Route as AgentProvided_job_postsIndexRouteImport } from './routes/agent_spa/agent/provided_job_posts/index'
import { Route as AgentProvided_job_post_listsIndexRouteImport } from './routes/agent_spa/agent/provided_job_post_lists/index'
import { Route as AgentProfitsIndexRouteImport } from './routes/agent_spa/agent/profits/index'
import { Route as AgentLinked_accountsIndexRouteImport } from './routes/agent_spa/agent/linked_accounts/index'
import { Route as AgentJob_change_processesIndexRouteImport } from './routes/agent_spa/agent/job_change_processes/index'
import { Route as AgentFormIndexRouteImport } from './routes/agent_spa/agent/form/index'
import { Route as AgentExport_requestsIndexRouteImport } from './routes/agent_spa/agent/export_requests/index'
import { Route as AgentCompaniesIndexRouteImport } from './routes/agent_spa/agent/companies/index'
import { Route as AgentCandidatesIndexRouteImport } from './routes/agent_spa/agent/candidates/index'
import { Route as AgentCandidate_mailsIndexRouteImport } from './routes/agent_spa/agent/candidate_mails/index'
import { Route as AgentAllianceIndexRouteImport } from './routes/agent_spa/agent/alliance/index'
import { Route as AgentLinked_accountsSharedRouteImport } from './routes/agent_spa/agent/linked_accounts/shared'
import { Route as AgentLinked_accountsIdRouteImport } from './routes/agent_spa/agent/linked_accounts/$id'
import { Route as AgentFormSettingsRouteImport } from './routes/agent_spa/agent/form/settings'
import { Route as AgentCandidate_mailsNewRouteImport } from './routes/agent_spa/agent/candidate_mails/new'
import { Route as AgentCandidate_mailsTemplatesNewRouteImport } from './routes/agent_spa/agent/candidate_mails/templates/new'
import { Route as AgentCandidate_mailsTemplatesTemplateIdEditRouteImport } from './routes/agent_spa/agent/candidate_mails/templates/$templateId/edit'
import { Route as AgentCompaniesNewRouteImport } from './routes/agent_spa/agent/companies/new'
import { Route as AccountSetupIdRouteImport } from './routes/agent_spa/account/setup.$id'
import { Route as AccountPasswordSettingRouteImport } from './routes/agent_spa/account/password/setting'
import { Route as AccountInviteTokenRouteImport } from './routes/agent_spa/account/invite.$token'
import { Route as AgentTrialTutorialIndexRouteImport } from './routes/agent_spa/agent/trial/tutorial/index'
import { Route as AgentProvided_job_postsProvidedJobPostsIdIndexRouteImport } from './routes/agent_spa/agent/provided_job_posts/$providedJobPostsId/index'
import { Route as AgentProvided_job_post_listsListIdIndexRouteImport } from './routes/agent_spa/agent/provided_job_post_lists/$listId/index'
import { Route as AgentLinked_accountsNewIndexRouteImport } from './routes/agent_spa/agent/linked_accounts/new/index'
import { Route as AgentCompaniesCompaniesIdIndexRouteImport } from './routes/agent_spa/agent/companies/$companiesId/index'
import { Route as AgentCandidatesNewIndexRouteImport } from './routes/agent_spa/agent/candidates/new/index'
import { Route as AgentCandidatesCandidateProfileIdIndexRouteImport } from './routes/agent_spa/agent/candidates/$candidateProfileId/index'
import { Route as AgentLinked_accountsNewSourceTypeRouteImport } from './routes/agent_spa/agent/linked_accounts/new/$sourceType'
import { Route as AccountPasswordResetTokenRouteImport } from './routes/agent_spa/account/password/reset.$token'
import { Route as AgentTrialAccountLinkIndexRouteImport } from './routes/agent_spa/agent/trial/account/link/index'
import { Route as AgentProvided_job_postsNewTextIndexRouteImport } from './routes/agent_spa/agent/provided_job_posts/new/text/index'
import { Route as AgentProvided_job_postsNewPdfIndexRouteImport } from './routes/agent_spa/agent/provided_job_posts/new/pdf/index'
import { Route as AgentProvided_job_postsNewManualIndexRouteImport } from './routes/agent_spa/agent/provided_job_posts/new/manual/index'
import { Route as AgentProvided_job_postsNewCsvIndexRouteImport } from './routes/agent_spa/agent/provided_job_posts/new/csv/index'
import { Route as AgentProvided_job_postsProvidedJobPostsIdEditIndexRouteImport } from './routes/agent_spa/agent/provided_job_posts/$providedJobPostsId/edit/index'
import { Route as AgentCandidatesCandidate_import_requestsNewIndexRouteImport } from './routes/agent_spa/agent/candidates/candidate_import_requests/new/index'
import { Route as AgentAllianceApplicationsApplicationIdIndexRouteImport } from './routes/agent_spa/agent/alliance/applications/$applicationId/index'
import { Route as AgentProvided_job_postsNewTextIdRouteImport } from './routes/agent_spa/agent/provided_job_posts/new/text/$id'
import { Route as AgentProvided_job_postsNewPdfIdRouteImport } from './routes/agent_spa/agent/provided_job_posts/new/pdf/$id'
import { Route as AgentLinked_accountsNewGroupGroupKeyRouteImport } from './routes/agent_spa/agent/linked_accounts/new/group/$groupKey'
import { Route as AgentProvided_job_postsNewCsvJobPostImportRequestIdIndexRouteImport } from './routes/agent_spa/agent/provided_job_posts/new/csv/$jobPostImportRequestId/index'
import { Route as AgentCandidatesCandidate_import_requestsPresetsPresetIdIndexRouteImport } from './routes/agent_spa/agent/candidates/candidate_import_requests/presets/$presetId/index'
import { Route as AgentCandidatesCandidate_import_requestsNewEncryptIdIndexRouteImport } from './routes/agent_spa/agent/candidates/candidate_import_requests/new/$encryptId/index'
import { Route as AgentCandidatesCandidateProfileIdInterview_logsNewIndexRouteImport } from './routes/agent_spa/agent/candidates/$candidateProfileId/interview_logs/new/index'

const AgentRoute = AgentRouteImport.update({
  id: '/agent',
  path: '/agent',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentIndexRoute = AgentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AgentRoute,
} as any)
const AgentJob_post_tagsRoute = AgentJob_post_tagsRouteImport.update({
  id: '/job_post_tags',
  path: '/job_post_tags',
  getParentRoute: () => AgentRoute,
} as any)
const AgentCustomizeRoute = AgentCustomizeRouteImport.update({
  id: '/customize',
  path: '/customize',
  getParentRoute: () => AgentRoute,
} as any)
const AgentCompany_tagsRoute = AgentCompany_tagsRouteImport.update({
  id: '/company_tags',
  path: '/company_tags',
  getParentRoute: () => AgentRoute,
} as any)
const AgentCandidate_tagsRoute = AgentCandidate_tagsRouteImport.update({
  id: '/candidate_tags',
  path: '/candidate_tags',
  getParentRoute: () => AgentRoute,
} as any)
const AgentAnalysisRoute = AgentAnalysisRouteImport.update({
  id: '/analysis',
  path: '/analysis',
  getParentRoute: () => AgentRoute,
} as any)
const AccountTrialRoute = AccountTrialRouteImport.update({
  id: '/account/trial',
  path: '/account/trial',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountLoginRoute = AccountLoginRouteImport.update({
  id: '/account/login',
  path: '/account/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentShared_job_postsIndexRoute =
  AgentShared_job_postsIndexRouteImport.update({
    id: '/shared_job_posts/',
    path: '/shared_job_posts/',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentSettingsIndexRoute = AgentSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AgentRoute,
} as any)
const AgentProvided_job_postsIndexRoute =
  AgentProvided_job_postsIndexRouteImport.update({
    id: '/provided_job_posts/',
    path: '/provided_job_posts/',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentProvided_job_post_listsIndexRoute =
  AgentProvided_job_post_listsIndexRouteImport.update({
    id: '/provided_job_post_lists/',
    path: '/provided_job_post_lists/',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentProfitsIndexRoute = AgentProfitsIndexRouteImport.update({
  id: '/profits/',
  path: '/profits/',
  getParentRoute: () => AgentRoute,
} as any)
const AgentLinked_accountsIndexRoute =
  AgentLinked_accountsIndexRouteImport.update({
    id: '/linked_accounts/',
    path: '/linked_accounts/',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentJob_change_processesIndexRoute =
  AgentJob_change_processesIndexRouteImport.update({
    id: '/job_change_processes/',
    path: '/job_change_processes/',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentFormIndexRoute = AgentFormIndexRouteImport.update({
  id: '/form/',
  path: '/form/',
  getParentRoute: () => AgentRoute,
} as any)
const AgentExport_requestsIndexRoute =
  AgentExport_requestsIndexRouteImport.update({
    id: '/export_requests/',
    path: '/export_requests/',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentCompaniesIndexRoute = AgentCompaniesIndexRouteImport.update({
  id: '/companies/',
  path: '/companies/',
  getParentRoute: () => AgentRoute,
} as any)
const AgentCandidatesIndexRoute = AgentCandidatesIndexRouteImport.update({
  id: '/candidates/',
  path: '/candidates/',
  getParentRoute: () => AgentRoute,
} as any)
const AgentCandidate_mailsIndexRoute =
  AgentCandidate_mailsIndexRouteImport.update({
    id: '/candidate_mails/',
    path: '/candidate_mails/',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentAllianceIndexRoute = AgentAllianceIndexRouteImport.update({
  id: '/alliance/',
  path: '/alliance/',
  getParentRoute: () => AgentRoute,
} as any)
const AgentLinked_accountsSharedRoute =
  AgentLinked_accountsSharedRouteImport.update({
    id: '/linked_accounts/shared',
    path: '/linked_accounts/shared',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentLinked_accountsIdRoute = AgentLinked_accountsIdRouteImport.update({
  id: '/linked_accounts/$id',
  path: '/linked_accounts/$id',
  getParentRoute: () => AgentRoute,
} as any)
const AgentFormSettingsRoute = AgentFormSettingsRouteImport.update({
  id: '/form/settings',
  path: '/form/settings',
  getParentRoute: () => AgentRoute,
} as any)
const AgentCandidate_mailsNewRoute = AgentCandidate_mailsNewRouteImport.update({
  id: '/candidate_mails/new',
  path: '/candidate_mails/new',
  getParentRoute: () => AgentRoute,
} as any)
const AgentCandidate_mailsTemplatesNewRoute = AgentCandidate_mailsTemplatesNewRouteImport.update({
  id: '/candidate_mails/templates/new',
  path: '/candidate_mails/templates/new',
  getParentRoute: () => AgentRoute,
} as any)
const AgentCandidate_mailsTemplatesTemplateIdEditRoute = AgentCandidate_mailsTemplatesTemplateIdEditRouteImport.update({
  id: '/candidate_mails/templates/$templateId/edit',
  path: '/candidate_mails/templates/$templateId/edit',
  getParentRoute: () => AgentRoute,
} as any)
const AgentCompaniesNewRoute = AgentCompaniesNewRouteImport.update({
  id: '/companies/new',
  path: '/companies/new',
  getParentRoute: () => AgentRoute,
} as any)
const AccountSetupIdRoute = AccountSetupIdRouteImport.update({
  id: '/account/setup/$id',
  path: '/account/setup/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountPasswordSettingRoute = AccountPasswordSettingRouteImport.update({
  id: '/account/password/setting',
  path: '/account/password/setting',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountInviteTokenRoute = AccountInviteTokenRouteImport.update({
  id: '/account/invite/$token',
  path: '/account/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentTrialTutorialIndexRoute = AgentTrialTutorialIndexRouteImport.update({
  id: '/trial/tutorial/',
  path: '/trial/tutorial/',
  getParentRoute: () => AgentRoute,
} as any)
const AgentProvided_job_postsProvidedJobPostsIdIndexRoute =
  AgentProvided_job_postsProvidedJobPostsIdIndexRouteImport.update({
    id: '/provided_job_posts/$providedJobPostsId/',
    path: '/provided_job_posts/$providedJobPostsId/',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentProvided_job_post_listsListIdIndexRoute =
  AgentProvided_job_post_listsListIdIndexRouteImport.update({
    id: '/provided_job_post_lists/$listId/',
    path: '/provided_job_post_lists/$listId/',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentLinked_accountsNewIndexRoute =
  AgentLinked_accountsNewIndexRouteImport.update({
    id: '/linked_accounts/new/',
    path: '/linked_accounts/new/',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentCompaniesCompaniesIdIndexRoute =
  AgentCompaniesCompaniesIdIndexRouteImport.update({
    id: '/companies/$companiesId/',
    path: '/companies/$companiesId/',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentCandidatesNewIndexRoute = AgentCandidatesNewIndexRouteImport.update({
  id: '/candidates/new/',
  path: '/candidates/new/',
  getParentRoute: () => AgentRoute,
} as any)
const AgentCandidatesCandidateProfileIdIndexRoute =
  AgentCandidatesCandidateProfileIdIndexRouteImport.update({
    id: '/candidates/$candidateProfileId/',
    path: '/candidates/$candidateProfileId/',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentLinked_accountsNewSourceTypeRoute =
  AgentLinked_accountsNewSourceTypeRouteImport.update({
    id: '/linked_accounts/new/$sourceType',
    path: '/linked_accounts/new/$sourceType',
    getParentRoute: () => AgentRoute,
  } as any)
const AccountPasswordResetTokenRoute =
  AccountPasswordResetTokenRouteImport.update({
    id: '/account/password/reset/$token',
    path: '/account/password/reset/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const AgentTrialAccountLinkIndexRoute =
  AgentTrialAccountLinkIndexRouteImport.update({
    id: '/trial/account/link/',
    path: '/trial/account/link/',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentProvided_job_postsNewTextIndexRoute =
  AgentProvided_job_postsNewTextIndexRouteImport.update({
    id: '/provided_job_posts/new/text/',
    path: '/provided_job_posts/new/text/',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentProvided_job_postsNewPdfIndexRoute =
  AgentProvided_job_postsNewPdfIndexRouteImport.update({
    id: '/provided_job_posts/new/pdf/',
    path: '/provided_job_posts/new/pdf/',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentProvided_job_postsNewManualIndexRoute =
  AgentProvided_job_postsNewManualIndexRouteImport.update({
    id: '/provided_job_posts/new/manual/',
    path: '/provided_job_posts/new/manual/',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentProvided_job_postsNewCsvIndexRoute =
  AgentProvided_job_postsNewCsvIndexRouteImport.update({
    id: '/provided_job_posts/new/csv/',
    path: '/provided_job_posts/new/csv/',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentProvided_job_postsProvidedJobPostsIdEditIndexRoute =
  AgentProvided_job_postsProvidedJobPostsIdEditIndexRouteImport.update({
    id: '/provided_job_posts/$providedJobPostsId/edit/',
    path: '/provided_job_posts/$providedJobPostsId/edit/',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentCandidatesCandidate_import_requestsNewIndexRoute =
  AgentCandidatesCandidate_import_requestsNewIndexRouteImport.update({
    id: '/candidates/candidate_import_requests/new/',
    path: '/candidates/candidate_import_requests/new/',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentAllianceApplicationsApplicationIdIndexRoute =
  AgentAllianceApplicationsApplicationIdIndexRouteImport.update({
    id: '/alliance/applications/$applicationId/',
    path: '/alliance/applications/$applicationId/',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentProvided_job_postsNewTextIdRoute =
  AgentProvided_job_postsNewTextIdRouteImport.update({
    id: '/provided_job_posts/new/text/$id',
    path: '/provided_job_posts/new/text/$id',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentProvided_job_postsNewPdfIdRoute =
  AgentProvided_job_postsNewPdfIdRouteImport.update({
    id: '/provided_job_posts/new/pdf/$id',
    path: '/provided_job_posts/new/pdf/$id',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentLinked_accountsNewGroupGroupKeyRoute =
  AgentLinked_accountsNewGroupGroupKeyRouteImport.update({
    id: '/linked_accounts/new/group/$groupKey',
    path: '/linked_accounts/new/group/$groupKey',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentProvided_job_postsNewCsvJobPostImportRequestIdIndexRoute =
  AgentProvided_job_postsNewCsvJobPostImportRequestIdIndexRouteImport.update({
    id: '/provided_job_posts/new/csv/$jobPostImportRequestId/',
    path: '/provided_job_posts/new/csv/$jobPostImportRequestId/',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentCandidatesCandidate_import_requestsPresetsPresetIdIndexRoute =
  AgentCandidatesCandidate_import_requestsPresetsPresetIdIndexRouteImport.update(
    {
      id: '/candidates/candidate_import_requests/presets/$presetId/',
      path: '/candidates/candidate_import_requests/presets/$presetId/',
      getParentRoute: () => AgentRoute,
    } as any,
  )
const AgentCandidatesCandidate_import_requestsNewEncryptIdIndexRoute =
  AgentCandidatesCandidate_import_requestsNewEncryptIdIndexRouteImport.update({
    id: '/candidates/candidate_import_requests/new/$encryptId/',
    path: '/candidates/candidate_import_requests/new/$encryptId/',
    getParentRoute: () => AgentRoute,
  } as any)
const AgentCandidatesCandidateProfileIdInterview_logsNewIndexRoute =
  AgentCandidatesCandidateProfileIdInterview_logsNewIndexRouteImport.update({
    id: '/candidates/$candidateProfileId/interview_logs/new/',
    path: '/candidates/$candidateProfileId/interview_logs/new/',
    getParentRoute: () => AgentRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/admin': typeof AdminRoute
  '/agent': typeof AgentRouteWithChildren
  '/account/login': typeof AccountLoginRoute
  '/account/trial': typeof AccountTrialRoute
  '/agent/analysis': typeof AgentAnalysisRoute
  '/agent/candidate_tags': typeof AgentCandidate_tagsRoute
  '/agent/company_tags': typeof AgentCompany_tagsRoute
  '/agent/customize': typeof AgentCustomizeRoute
  '/agent/job_post_tags': typeof AgentJob_post_tagsRoute
  '/agent/': typeof AgentIndexRoute
  '/account/invite/$token': typeof AccountInviteTokenRoute
  '/account/password/setting': typeof AccountPasswordSettingRoute
  '/account/setup/$id': typeof AccountSetupIdRoute
  '/agent/companies/new': typeof AgentCompaniesNewRoute
  '/agent/form/settings': typeof AgentFormSettingsRoute
  '/agent/candidate_mails/new': typeof AgentCandidate_mailsNewRoute
  '/agent/candidate_mails/templates/new': typeof AgentCandidate_mailsTemplatesNewRoute
  '/agent/candidate_mails/templates/$templateId/edit': typeof AgentCandidate_mailsTemplatesTemplateIdEditRoute
  '/agent/linked_accounts/$id': typeof AgentLinked_accountsIdRoute
  '/agent/linked_accounts/shared': typeof AgentLinked_accountsSharedRoute
  '/agent/alliance': typeof AgentAllianceIndexRoute
  '/agent/candidate_mails': typeof AgentCandidate_mailsIndexRoute
  '/agent/candidates': typeof AgentCandidatesIndexRoute
  '/agent/companies': typeof AgentCompaniesIndexRoute
  '/agent/export_requests': typeof AgentExport_requestsIndexRoute
  '/agent/form': typeof AgentFormIndexRoute
  '/agent/job_change_processes': typeof AgentJob_change_processesIndexRoute
  '/agent/linked_accounts': typeof AgentLinked_accountsIndexRoute
  '/agent/profits': typeof AgentProfitsIndexRoute
  '/agent/provided_job_post_lists': typeof AgentProvided_job_post_listsIndexRoute
  '/agent/provided_job_posts': typeof AgentProvided_job_postsIndexRoute
  '/agent/settings': typeof AgentSettingsIndexRoute
  '/agent/shared_job_posts': typeof AgentShared_job_postsIndexRoute
  '/account/password/reset/$token': typeof AccountPasswordResetTokenRoute
  '/agent/linked_accounts/new/$sourceType': typeof AgentLinked_accountsNewSourceTypeRoute
  '/agent/candidates/$candidateProfileId': typeof AgentCandidatesCandidateProfileIdIndexRoute
  '/agent/candidates/new': typeof AgentCandidatesNewIndexRoute
  '/agent/companies/$companiesId': typeof AgentCompaniesCompaniesIdIndexRoute
  '/agent/linked_accounts/new': typeof AgentLinked_accountsNewIndexRoute
  '/agent/provided_job_post_lists/$listId': typeof AgentProvided_job_post_listsListIdIndexRoute
  '/agent/provided_job_posts/$providedJobPostsId': typeof AgentProvided_job_postsProvidedJobPostsIdIndexRoute
  '/agent/trial/tutorial': typeof AgentTrialTutorialIndexRoute
  '/agent/linked_accounts/new/group/$groupKey': typeof AgentLinked_accountsNewGroupGroupKeyRoute
  '/agent/provided_job_posts/new/pdf/$id': typeof AgentProvided_job_postsNewPdfIdRoute
  '/agent/provided_job_posts/new/text/$id': typeof AgentProvided_job_postsNewTextIdRoute
  '/agent/alliance/applications/$applicationId': typeof AgentAllianceApplicationsApplicationIdIndexRoute
  '/agent/candidates/candidate_import_requests/new': typeof AgentCandidatesCandidate_import_requestsNewIndexRoute
  '/agent/provided_job_posts/$providedJobPostsId/edit': typeof AgentProvided_job_postsProvidedJobPostsIdEditIndexRoute
  '/agent/provided_job_posts/new/csv': typeof AgentProvided_job_postsNewCsvIndexRoute
  '/agent/provided_job_posts/new/manual': typeof AgentProvided_job_postsNewManualIndexRoute
  '/agent/provided_job_posts/new/pdf': typeof AgentProvided_job_postsNewPdfIndexRoute
  '/agent/provided_job_posts/new/text': typeof AgentProvided_job_postsNewTextIndexRoute
  '/agent/trial/account/link': typeof AgentTrialAccountLinkIndexRoute
  '/agent/candidates/$candidateProfileId/interview_logs/new': typeof AgentCandidatesCandidateProfileIdInterview_logsNewIndexRoute
  '/agent/candidates/candidate_import_requests/new/$encryptId': typeof AgentCandidatesCandidate_import_requestsNewEncryptIdIndexRoute
  '/agent/candidates/candidate_import_requests/presets/$presetId': typeof AgentCandidatesCandidate_import_requestsPresetsPresetIdIndexRoute
  '/agent/provided_job_posts/new/csv/$jobPostImportRequestId': typeof AgentProvided_job_postsNewCsvJobPostImportRequestIdIndexRoute
}
export interface FileRoutesByTo {
  '/admin': typeof AdminRoute
  '/account/login': typeof AccountLoginRoute
  '/account/trial': typeof AccountTrialRoute
  '/agent/analysis': typeof AgentAnalysisRoute
  '/agent/candidate_tags': typeof AgentCandidate_tagsRoute
  '/agent/company_tags': typeof AgentCompany_tagsRoute
  '/agent/customize': typeof AgentCustomizeRoute
  '/agent/job_post_tags': typeof AgentJob_post_tagsRoute
  '/agent': typeof AgentIndexRoute
  '/account/invite/$token': typeof AccountInviteTokenRoute
  '/account/password/setting': typeof AccountPasswordSettingRoute
  '/account/setup/$id': typeof AccountSetupIdRoute
  '/agent/companies/new': typeof AgentCompaniesNewRoute
  '/agent/form/settings': typeof AgentFormSettingsRoute
  '/agent/candidate_mails/new': typeof AgentCandidate_mailsNewRoute
  '/agent/candidate_mails/templates/new': typeof AgentCandidate_mailsTemplatesNewRoute
  '/agent/candidate_mails/templates/$templateId/edit': typeof AgentCandidate_mailsTemplatesTemplateIdEditRoute
  '/agent/linked_accounts/$id': typeof AgentLinked_accountsIdRoute
  '/agent/linked_accounts/shared': typeof AgentLinked_accountsSharedRoute
  '/agent/alliance': typeof AgentAllianceIndexRoute
  '/agent/candidate_mails': typeof AgentCandidate_mailsIndexRoute
  '/agent/candidates': typeof AgentCandidatesIndexRoute
  '/agent/companies': typeof AgentCompaniesIndexRoute
  '/agent/export_requests': typeof AgentExport_requestsIndexRoute
  '/agent/form': typeof AgentFormIndexRoute
  '/agent/job_change_processes': typeof AgentJob_change_processesIndexRoute
  '/agent/linked_accounts': typeof AgentLinked_accountsIndexRoute
  '/agent/profits': typeof AgentProfitsIndexRoute
  '/agent/provided_job_post_lists': typeof AgentProvided_job_post_listsIndexRoute
  '/agent/provided_job_posts': typeof AgentProvided_job_postsIndexRoute
  '/agent/settings': typeof AgentSettingsIndexRoute
  '/agent/shared_job_posts': typeof AgentShared_job_postsIndexRoute
  '/account/password/reset/$token': typeof AccountPasswordResetTokenRoute
  '/agent/linked_accounts/new/$sourceType': typeof AgentLinked_accountsNewSourceTypeRoute
  '/agent/candidates/$candidateProfileId': typeof AgentCandidatesCandidateProfileIdIndexRoute
  '/agent/candidates/new': typeof AgentCandidatesNewIndexRoute
  '/agent/companies/$companiesId': typeof AgentCompaniesCompaniesIdIndexRoute
  '/agent/linked_accounts/new': typeof AgentLinked_accountsNewIndexRoute
  '/agent/provided_job_post_lists/$listId': typeof AgentProvided_job_post_listsListIdIndexRoute
  '/agent/provided_job_posts/$providedJobPostsId': typeof AgentProvided_job_postsProvidedJobPostsIdIndexRoute
  '/agent/trial/tutorial': typeof AgentTrialTutorialIndexRoute
  '/agent/linked_accounts/new/group/$groupKey': typeof AgentLinked_accountsNewGroupGroupKeyRoute
  '/agent/provided_job_posts/new/pdf/$id': typeof AgentProvided_job_postsNewPdfIdRoute
  '/agent/provided_job_posts/new/text/$id': typeof AgentProvided_job_postsNewTextIdRoute
  '/agent/alliance/applications/$applicationId': typeof AgentAllianceApplicationsApplicationIdIndexRoute
  '/agent/candidates/candidate_import_requests/new': typeof AgentCandidatesCandidate_import_requestsNewIndexRoute
  '/agent/provided_job_posts/$providedJobPostsId/edit': typeof AgentProvided_job_postsProvidedJobPostsIdEditIndexRoute
  '/agent/provided_job_posts/new/csv': typeof AgentProvided_job_postsNewCsvIndexRoute
  '/agent/provided_job_posts/new/manual': typeof AgentProvided_job_postsNewManualIndexRoute
  '/agent/provided_job_posts/new/pdf': typeof AgentProvided_job_postsNewPdfIndexRoute
  '/agent/provided_job_posts/new/text': typeof AgentProvided_job_postsNewTextIndexRoute
  '/agent/trial/account/link': typeof AgentTrialAccountLinkIndexRoute
  '/agent/candidates/$candidateProfileId/interview_logs/new': typeof AgentCandidatesCandidateProfileIdInterview_logsNewIndexRoute
  '/agent/candidates/candidate_import_requests/new/$encryptId': typeof AgentCandidatesCandidate_import_requestsNewEncryptIdIndexRoute
  '/agent/candidates/candidate_import_requests/presets/$presetId': typeof AgentCandidatesCandidate_import_requestsPresetsPresetIdIndexRoute
  '/agent/provided_job_posts/new/csv/$jobPostImportRequestId': typeof AgentProvided_job_postsNewCsvJobPostImportRequestIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/admin': typeof AdminRoute
  '/agent': typeof AgentRouteWithChildren
  '/account/login': typeof AccountLoginRoute
  '/account/trial': typeof AccountTrialRoute
  '/agent/analysis': typeof AgentAnalysisRoute
  '/agent/candidate_tags': typeof AgentCandidate_tagsRoute
  '/agent/company_tags': typeof AgentCompany_tagsRoute
  '/agent/customize': typeof AgentCustomizeRoute
  '/agent/job_post_tags': typeof AgentJob_post_tagsRoute
  '/agent/': typeof AgentIndexRoute
  '/account/invite/$token': typeof AccountInviteTokenRoute
  '/account/password/setting': typeof AccountPasswordSettingRoute
  '/account/setup/$id': typeof AccountSetupIdRoute
  '/agent/companies/new': typeof AgentCompaniesNewRoute
  '/agent/form/settings': typeof AgentFormSettingsRoute
  '/agent/candidate_mails/new': typeof AgentCandidate_mailsNewRoute
  '/agent/candidate_mails/templates/new': typeof AgentCandidate_mailsTemplatesNewRoute
  '/agent/candidate_mails/templates/$templateId/edit': typeof AgentCandidate_mailsTemplatesTemplateIdEditRoute
  '/agent/linked_accounts/$id': typeof AgentLinked_accountsIdRoute
  '/agent/linked_accounts/shared': typeof AgentLinked_accountsSharedRoute
  '/agent/alliance/': typeof AgentAllianceIndexRoute
  '/agent/candidate_mails/': typeof AgentCandidate_mailsIndexRoute
  '/agent/candidates/': typeof AgentCandidatesIndexRoute
  '/agent/companies/': typeof AgentCompaniesIndexRoute
  '/agent/export_requests/': typeof AgentExport_requestsIndexRoute
  '/agent/form/': typeof AgentFormIndexRoute
  '/agent/job_change_processes/': typeof AgentJob_change_processesIndexRoute
  '/agent/linked_accounts/': typeof AgentLinked_accountsIndexRoute
  '/agent/profits/': typeof AgentProfitsIndexRoute
  '/agent/provided_job_post_lists/': typeof AgentProvided_job_post_listsIndexRoute
  '/agent/provided_job_posts/': typeof AgentProvided_job_postsIndexRoute
  '/agent/settings/': typeof AgentSettingsIndexRoute
  '/agent/shared_job_posts/': typeof AgentShared_job_postsIndexRoute
  '/account/password/reset/$token': typeof AccountPasswordResetTokenRoute
  '/agent/linked_accounts/new/$sourceType': typeof AgentLinked_accountsNewSourceTypeRoute
  '/agent/candidates/$candidateProfileId/': typeof AgentCandidatesCandidateProfileIdIndexRoute
  '/agent/candidates/new/': typeof AgentCandidatesNewIndexRoute
  '/agent/companies/$companiesId/': typeof AgentCompaniesCompaniesIdIndexRoute
  '/agent/linked_accounts/new/': typeof AgentLinked_accountsNewIndexRoute
  '/agent/provided_job_post_lists/$listId/': typeof AgentProvided_job_post_listsListIdIndexRoute
  '/agent/provided_job_posts/$providedJobPostsId/': typeof AgentProvided_job_postsProvidedJobPostsIdIndexRoute
  '/agent/trial/tutorial/': typeof AgentTrialTutorialIndexRoute
  '/agent/linked_accounts/new/group/$groupKey': typeof AgentLinked_accountsNewGroupGroupKeyRoute
  '/agent/provided_job_posts/new/pdf/$id': typeof AgentProvided_job_postsNewPdfIdRoute
  '/agent/provided_job_posts/new/text/$id': typeof AgentProvided_job_postsNewTextIdRoute
  '/agent/alliance/applications/$applicationId/': typeof AgentAllianceApplicationsApplicationIdIndexRoute
  '/agent/candidates/candidate_import_requests/new/': typeof AgentCandidatesCandidate_import_requestsNewIndexRoute
  '/agent/provided_job_posts/$providedJobPostsId/edit/': typeof AgentProvided_job_postsProvidedJobPostsIdEditIndexRoute
  '/agent/provided_job_posts/new/csv/': typeof AgentProvided_job_postsNewCsvIndexRoute
  '/agent/provided_job_posts/new/manual/': typeof AgentProvided_job_postsNewManualIndexRoute
  '/agent/provided_job_posts/new/pdf/': typeof AgentProvided_job_postsNewPdfIndexRoute
  '/agent/provided_job_posts/new/text/': typeof AgentProvided_job_postsNewTextIndexRoute
  '/agent/trial/account/link/': typeof AgentTrialAccountLinkIndexRoute
  '/agent/candidates/$candidateProfileId/interview_logs/new/': typeof AgentCandidatesCandidateProfileIdInterview_logsNewIndexRoute
  '/agent/candidates/candidate_import_requests/new/$encryptId/': typeof AgentCandidatesCandidate_import_requestsNewEncryptIdIndexRoute
  '/agent/candidates/candidate_import_requests/presets/$presetId/': typeof AgentCandidatesCandidate_import_requestsPresetsPresetIdIndexRoute
  '/agent/provided_job_posts/new/csv/$jobPostImportRequestId/': typeof AgentProvided_job_postsNewCsvJobPostImportRequestIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/admin'
    | '/agent'
    | '/account/login'
    | '/account/trial'
    | '/agent/analysis'
    | '/agent/candidate_tags'
    | '/agent/company_tags'
    | '/agent/customize'
    | '/agent/job_post_tags'
    | '/agent/'
    | '/account/invite/$token'
    | '/account/password/setting'
    | '/account/setup/$id'
    | '/agent/companies/new'
    | '/agent/form/settings'
    | '/agent/candidate_mails/new'
    | '/agent/candidate_mails/templates/new'
    | '/agent/candidate_mails/templates/$templateId/edit'
    | '/agent/linked_accounts/$id'
    | '/agent/linked_accounts/shared'
    | '/agent/alliance'
    | '/agent/candidate_mails'
    | '/agent/candidates'
    | '/agent/companies'
    | '/agent/export_requests'
    | '/agent/form'
    | '/agent/job_change_processes'
    | '/agent/linked_accounts'
    | '/agent/profits'
    | '/agent/provided_job_post_lists'
    | '/agent/provided_job_posts'
    | '/agent/settings'
    | '/agent/shared_job_posts'
    | '/account/password/reset/$token'
    | '/agent/linked_accounts/new/$sourceType'
    | '/agent/candidates/$candidateProfileId'
    | '/agent/candidates/new'
    | '/agent/companies/$companiesId'
    | '/agent/linked_accounts/new'
    | '/agent/provided_job_post_lists/$listId'
    | '/agent/provided_job_posts/$providedJobPostsId'
    | '/agent/trial/tutorial'
    | '/agent/linked_accounts/new/group/$groupKey'
    | '/agent/provided_job_posts/new/pdf/$id'
    | '/agent/provided_job_posts/new/text/$id'
    | '/agent/alliance/applications/$applicationId'
    | '/agent/candidates/candidate_import_requests/new'
    | '/agent/provided_job_posts/$providedJobPostsId/edit'
    | '/agent/provided_job_posts/new/csv'
    | '/agent/provided_job_posts/new/manual'
    | '/agent/provided_job_posts/new/pdf'
    | '/agent/provided_job_posts/new/text'
    | '/agent/trial/account/link'
    | '/agent/candidates/$candidateProfileId/interview_logs/new'
    | '/agent/candidates/candidate_import_requests/new/$encryptId'
    | '/agent/candidates/candidate_import_requests/presets/$presetId'
    | '/agent/provided_job_posts/new/csv/$jobPostImportRequestId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/admin'
    | '/account/login'
    | '/account/trial'
    | '/agent/analysis'
    | '/agent/candidate_tags'
    | '/agent/company_tags'
    | '/agent/customize'
    | '/agent/job_post_tags'
    | '/agent'
    | '/account/invite/$token'
    | '/account/password/setting'
    | '/account/setup/$id'
    | '/agent/companies/new'
    | '/agent/form/settings'
    | '/agent/candidate_mails/new'
    | '/agent/candidate_mails/templates/new'
    | '/agent/candidate_mails/templates/$templateId/edit'
    | '/agent/linked_accounts/$id'
    | '/agent/linked_accounts/shared'
    | '/agent/alliance'
    | '/agent/candidate_mails'
    | '/agent/candidates'
    | '/agent/companies'
    | '/agent/export_requests'
    | '/agent/form'
    | '/agent/job_change_processes'
    | '/agent/linked_accounts'
    | '/agent/profits'
    | '/agent/provided_job_post_lists'
    | '/agent/provided_job_posts'
    | '/agent/settings'
    | '/agent/shared_job_posts'
    | '/account/password/reset/$token'
    | '/agent/linked_accounts/new/$sourceType'
    | '/agent/candidates/$candidateProfileId'
    | '/agent/candidates/new'
    | '/agent/companies/$companiesId'
    | '/agent/linked_accounts/new'
    | '/agent/provided_job_post_lists/$listId'
    | '/agent/provided_job_posts/$providedJobPostsId'
    | '/agent/trial/tutorial'
    | '/agent/linked_accounts/new/group/$groupKey'
    | '/agent/provided_job_posts/new/pdf/$id'
    | '/agent/provided_job_posts/new/text/$id'
    | '/agent/alliance/applications/$applicationId'
    | '/agent/candidates/candidate_import_requests/new'
    | '/agent/provided_job_posts/$providedJobPostsId/edit'
    | '/agent/provided_job_posts/new/csv'
    | '/agent/provided_job_posts/new/manual'
    | '/agent/provided_job_posts/new/pdf'
    | '/agent/provided_job_posts/new/text'
    | '/agent/trial/account/link'
    | '/agent/candidates/$candidateProfileId/interview_logs/new'
    | '/agent/candidates/candidate_import_requests/new/$encryptId'
    | '/agent/candidates/candidate_import_requests/presets/$presetId'
    | '/agent/provided_job_posts/new/csv/$jobPostImportRequestId'
  id:
    | '__root__'
    | '/admin'
    | '/agent'
    | '/account/login'
    | '/account/trial'
    | '/agent/analysis'
    | '/agent/candidate_tags'
    | '/agent/company_tags'
    | '/agent/customize'
    | '/agent/job_post_tags'
    | '/agent/'
    | '/account/invite/$token'
    | '/account/password/setting'
    | '/account/setup/$id'
    | '/agent/companies/new'
    | '/agent/form/settings'
    | '/agent/candidate_mails/new'
    | '/agent/candidate_mails/templates/new'
    | '/agent/candidate_mails/templates/$templateId/edit'
    | '/agent/linked_accounts/$id'
    | '/agent/linked_accounts/shared'
    | '/agent/alliance/'
    | '/agent/candidate_mails/'
    | '/agent/candidates/'
    | '/agent/companies/'
    | '/agent/export_requests/'
    | '/agent/form/'
    | '/agent/job_change_processes/'
    | '/agent/linked_accounts/'
    | '/agent/profits/'
    | '/agent/provided_job_post_lists/'
    | '/agent/provided_job_posts/'
    | '/agent/settings/'
    | '/agent/shared_job_posts/'
    | '/account/password/reset/$token'
    | '/agent/linked_accounts/new/$sourceType'
    | '/agent/candidates/$candidateProfileId/'
    | '/agent/candidates/new/'
    | '/agent/companies/$companiesId/'
    | '/agent/linked_accounts/new/'
    | '/agent/provided_job_post_lists/$listId/'
    | '/agent/provided_job_posts/$providedJobPostsId/'
    | '/agent/trial/tutorial/'
    | '/agent/linked_accounts/new/group/$groupKey'
    | '/agent/provided_job_posts/new/pdf/$id'
    | '/agent/provided_job_posts/new/text/$id'
    | '/agent/alliance/applications/$applicationId/'
    | '/agent/candidates/candidate_import_requests/new/'
    | '/agent/provided_job_posts/$providedJobPostsId/edit/'
    | '/agent/provided_job_posts/new/csv/'
    | '/agent/provided_job_posts/new/manual/'
    | '/agent/provided_job_posts/new/pdf/'
    | '/agent/provided_job_posts/new/text/'
    | '/agent/trial/account/link/'
    | '/agent/candidates/$candidateProfileId/interview_logs/new/'
    | '/agent/candidates/candidate_import_requests/new/$encryptId/'
    | '/agent/candidates/candidate_import_requests/presets/$presetId/'
    | '/agent/provided_job_posts/new/csv/$jobPostImportRequestId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AdminRoute: typeof AdminRoute
  AgentRoute: typeof AgentRouteWithChildren
  AccountLoginRoute: typeof AccountLoginRoute
  AccountTrialRoute: typeof AccountTrialRoute
  AccountInviteTokenRoute: typeof AccountInviteTokenRoute
  AccountPasswordSettingRoute: typeof AccountPasswordSettingRoute
  AccountSetupIdRoute: typeof AccountSetupIdRoute
  AccountPasswordResetTokenRoute: typeof AccountPasswordResetTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/agent': {
      id: '/agent'
      path: '/agent'
      fullPath: '/agent'
      preLoaderRoute: typeof AgentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent/': {
      id: '/agent/'
      path: '/'
      fullPath: '/agent/'
      preLoaderRoute: typeof AgentIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/job_post_tags': {
      id: '/agent/job_post_tags'
      path: '/job_post_tags'
      fullPath: '/agent/job_post_tags'
      preLoaderRoute: typeof AgentJob_post_tagsRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/customize': {
      id: '/agent/customize'
      path: '/customize'
      fullPath: '/agent/customize'
      preLoaderRoute: typeof AgentCustomizeRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/company_tags': {
      id: '/agent/company_tags'
      path: '/company_tags'
      fullPath: '/agent/company_tags'
      preLoaderRoute: typeof AgentCompany_tagsRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/candidate_tags': {
      id: '/agent/candidate_tags'
      path: '/candidate_tags'
      fullPath: '/agent/candidate_tags'
      preLoaderRoute: typeof AgentCandidate_tagsRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/analysis': {
      id: '/agent/analysis'
      path: '/analysis'
      fullPath: '/agent/analysis'
      preLoaderRoute: typeof AgentAnalysisRouteImport
      parentRoute: typeof AgentRoute
    }
    '/account/trial': {
      id: '/account/trial'
      path: '/account/trial'
      fullPath: '/account/trial'
      preLoaderRoute: typeof AccountTrialRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/login': {
      id: '/account/login'
      path: '/account/login'
      fullPath: '/account/login'
      preLoaderRoute: typeof AccountLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent/shared_job_posts/': {
      id: '/agent/shared_job_posts/'
      path: '/shared_job_posts'
      fullPath: '/agent/shared_job_posts'
      preLoaderRoute: typeof AgentShared_job_postsIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/settings/': {
      id: '/agent/settings/'
      path: '/settings'
      fullPath: '/agent/settings'
      preLoaderRoute: typeof AgentSettingsIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/provided_job_posts/': {
      id: '/agent/provided_job_posts/'
      path: '/provided_job_posts'
      fullPath: '/agent/provided_job_posts'
      preLoaderRoute: typeof AgentProvided_job_postsIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/provided_job_post_lists/': {
      id: '/agent/provided_job_post_lists/'
      path: '/provided_job_post_lists'
      fullPath: '/agent/provided_job_post_lists'
      preLoaderRoute: typeof AgentProvided_job_post_listsIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/profits/': {
      id: '/agent/profits/'
      path: '/profits'
      fullPath: '/agent/profits'
      preLoaderRoute: typeof AgentProfitsIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/linked_accounts/': {
      id: '/agent/linked_accounts/'
      path: '/linked_accounts'
      fullPath: '/agent/linked_accounts'
      preLoaderRoute: typeof AgentLinked_accountsIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/job_change_processes/': {
      id: '/agent/job_change_processes/'
      path: '/job_change_processes'
      fullPath: '/agent/job_change_processes'
      preLoaderRoute: typeof AgentJob_change_processesIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/form/': {
      id: '/agent/form/'
      path: '/form'
      fullPath: '/agent/form'
      preLoaderRoute: typeof AgentFormIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/export_requests/': {
      id: '/agent/export_requests/'
      path: '/export_requests'
      fullPath: '/agent/export_requests'
      preLoaderRoute: typeof AgentExport_requestsIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/companies/': {
      id: '/agent/companies/'
      path: '/companies'
      fullPath: '/agent/companies'
      preLoaderRoute: typeof AgentCompaniesIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/candidates/': {
      id: '/agent/candidates/'
      path: '/candidates'
      fullPath: '/agent/candidates'
      preLoaderRoute: typeof AgentCandidatesIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/candidate_mails/': {
      id: '/agent/candidate_mails/'
      path: '/candidate_mails'
      fullPath: '/agent/candidate_mails'
      preLoaderRoute: typeof AgentCandidate_mailsIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/alliance/': {
      id: '/agent/alliance/'
      path: '/alliance'
      fullPath: '/agent/alliance'
      preLoaderRoute: typeof AgentAllianceIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/linked_accounts/shared': {
      id: '/agent/linked_accounts/shared'
      path: '/linked_accounts/shared'
      fullPath: '/agent/linked_accounts/shared'
      preLoaderRoute: typeof AgentLinked_accountsSharedRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/linked_accounts/$id': {
      id: '/agent/linked_accounts/$id'
      path: '/linked_accounts/$id'
      fullPath: '/agent/linked_accounts/$id'
      preLoaderRoute: typeof AgentLinked_accountsIdRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/form/settings': {
      id: '/agent/form/settings'
      path: '/form/settings'
      fullPath: '/agent/form/settings'
      preLoaderRoute: typeof AgentFormSettingsRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/candidate_mails/new': {
      id: '/agent/candidate_mails/new'
      path: '/candidate_mails/new'
      fullPath: '/agent/candidate_mails/new'
      preLoaderRoute: typeof AgentCandidate_mailsNewRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/candidate_mails/templates/new': {
      id: '/agent/candidate_mails/templates/new'
      path: '/candidate_mails/templates/new'
      fullPath: '/agent/candidate_mails/templates/new'
      preLoaderRoute: typeof AgentCandidate_mailsTemplatesNewRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/candidate_mails/templates/$templateId/edit': {
      id: '/agent/candidate_mails/templates/$templateId/edit'
      path: '/candidate_mails/templates/$templateId/edit'
      fullPath: '/agent/candidate_mails/templates/$templateId/edit'
      preLoaderRoute: typeof AgentCandidate_mailsTemplatesTemplateIdEditRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/companies/new': {
      id: '/agent/companies/new'
      path: '/companies/new'
      fullPath: '/agent/companies/new'
      preLoaderRoute: typeof AgentCompaniesNewRouteImport
      parentRoute: typeof AgentRoute
    }
    '/account/setup/$id': {
      id: '/account/setup/$id'
      path: '/account/setup/$id'
      fullPath: '/account/setup/$id'
      preLoaderRoute: typeof AccountSetupIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/password/setting': {
      id: '/account/password/setting'
      path: '/account/password/setting'
      fullPath: '/account/password/setting'
      preLoaderRoute: typeof AccountPasswordSettingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/invite/$token': {
      id: '/account/invite/$token'
      path: '/account/invite/$token'
      fullPath: '/account/invite/$token'
      preLoaderRoute: typeof AccountInviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent/trial/tutorial/': {
      id: '/agent/trial/tutorial/'
      path: '/trial/tutorial'
      fullPath: '/agent/trial/tutorial'
      preLoaderRoute: typeof AgentTrialTutorialIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/provided_job_posts/$providedJobPostsId/': {
      id: '/agent/provided_job_posts/$providedJobPostsId/'
      path: '/provided_job_posts/$providedJobPostsId'
      fullPath: '/agent/provided_job_posts/$providedJobPostsId'
      preLoaderRoute: typeof AgentProvided_job_postsProvidedJobPostsIdIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/provided_job_post_lists/$listId/': {
      id: '/agent/provided_job_post_lists/$listId/'
      path: '/provided_job_post_lists/$listId'
      fullPath: '/agent/provided_job_post_lists/$listId'
      preLoaderRoute: typeof AgentProvided_job_post_listsListIdIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/linked_accounts/new/': {
      id: '/agent/linked_accounts/new/'
      path: '/linked_accounts/new'
      fullPath: '/agent/linked_accounts/new'
      preLoaderRoute: typeof AgentLinked_accountsNewIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/companies/$companiesId/': {
      id: '/agent/companies/$companiesId/'
      path: '/companies/$companiesId'
      fullPath: '/agent/companies/$companiesId'
      preLoaderRoute: typeof AgentCompaniesCompaniesIdIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/candidates/new/': {
      id: '/agent/candidates/new/'
      path: '/candidates/new'
      fullPath: '/agent/candidates/new'
      preLoaderRoute: typeof AgentCandidatesNewIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/candidates/$candidateProfileId/': {
      id: '/agent/candidates/$candidateProfileId/'
      path: '/candidates/$candidateProfileId'
      fullPath: '/agent/candidates/$candidateProfileId'
      preLoaderRoute: typeof AgentCandidatesCandidateProfileIdIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/linked_accounts/new/$sourceType': {
      id: '/agent/linked_accounts/new/$sourceType'
      path: '/linked_accounts/new/$sourceType'
      fullPath: '/agent/linked_accounts/new/$sourceType'
      preLoaderRoute: typeof AgentLinked_accountsNewSourceTypeRouteImport
      parentRoute: typeof AgentRoute
    }
    '/account/password/reset/$token': {
      id: '/account/password/reset/$token'
      path: '/account/password/reset/$token'
      fullPath: '/account/password/reset/$token'
      preLoaderRoute: typeof AccountPasswordResetTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent/trial/account/link/': {
      id: '/agent/trial/account/link/'
      path: '/trial/account/link'
      fullPath: '/agent/trial/account/link'
      preLoaderRoute: typeof AgentTrialAccountLinkIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/provided_job_posts/new/text/': {
      id: '/agent/provided_job_posts/new/text/'
      path: '/provided_job_posts/new/text'
      fullPath: '/agent/provided_job_posts/new/text'
      preLoaderRoute: typeof AgentProvided_job_postsNewTextIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/provided_job_posts/new/pdf/': {
      id: '/agent/provided_job_posts/new/pdf/'
      path: '/provided_job_posts/new/pdf'
      fullPath: '/agent/provided_job_posts/new/pdf'
      preLoaderRoute: typeof AgentProvided_job_postsNewPdfIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/provided_job_posts/new/manual/': {
      id: '/agent/provided_job_posts/new/manual/'
      path: '/provided_job_posts/new/manual'
      fullPath: '/agent/provided_job_posts/new/manual'
      preLoaderRoute: typeof AgentProvided_job_postsNewManualIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/provided_job_posts/new/csv/': {
      id: '/agent/provided_job_posts/new/csv/'
      path: '/provided_job_posts/new/csv'
      fullPath: '/agent/provided_job_posts/new/csv'
      preLoaderRoute: typeof AgentProvided_job_postsNewCsvIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/provided_job_posts/$providedJobPostsId/edit/': {
      id: '/agent/provided_job_posts/$providedJobPostsId/edit/'
      path: '/provided_job_posts/$providedJobPostsId/edit'
      fullPath: '/agent/provided_job_posts/$providedJobPostsId/edit'
      preLoaderRoute: typeof AgentProvided_job_postsProvidedJobPostsIdEditIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/candidates/candidate_import_requests/new/': {
      id: '/agent/candidates/candidate_import_requests/new/'
      path: '/candidates/candidate_import_requests/new'
      fullPath: '/agent/candidates/candidate_import_requests/new'
      preLoaderRoute: typeof AgentCandidatesCandidate_import_requestsNewIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/alliance/applications/$applicationId/': {
      id: '/agent/alliance/applications/$applicationId/'
      path: '/alliance/applications/$applicationId'
      fullPath: '/agent/alliance/applications/$applicationId'
      preLoaderRoute: typeof AgentAllianceApplicationsApplicationIdIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/provided_job_posts/new/text/$id': {
      id: '/agent/provided_job_posts/new/text/$id'
      path: '/provided_job_posts/new/text/$id'
      fullPath: '/agent/provided_job_posts/new/text/$id'
      preLoaderRoute: typeof AgentProvided_job_postsNewTextIdRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/provided_job_posts/new/pdf/$id': {
      id: '/agent/provided_job_posts/new/pdf/$id'
      path: '/provided_job_posts/new/pdf/$id'
      fullPath: '/agent/provided_job_posts/new/pdf/$id'
      preLoaderRoute: typeof AgentProvided_job_postsNewPdfIdRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/linked_accounts/new/group/$groupKey': {
      id: '/agent/linked_accounts/new/group/$groupKey'
      path: '/linked_accounts/new/group/$groupKey'
      fullPath: '/agent/linked_accounts/new/group/$groupKey'
      preLoaderRoute: typeof AgentLinked_accountsNewGroupGroupKeyRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/provided_job_posts/new/csv/$jobPostImportRequestId/': {
      id: '/agent/provided_job_posts/new/csv/$jobPostImportRequestId/'
      path: '/provided_job_posts/new/csv/$jobPostImportRequestId'
      fullPath: '/agent/provided_job_posts/new/csv/$jobPostImportRequestId'
      preLoaderRoute: typeof AgentProvided_job_postsNewCsvJobPostImportRequestIdIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/candidates/candidate_import_requests/presets/$presetId/': {
      id: '/agent/candidates/candidate_import_requests/presets/$presetId/'
      path: '/candidates/candidate_import_requests/presets/$presetId'
      fullPath: '/agent/candidates/candidate_import_requests/presets/$presetId'
      preLoaderRoute: typeof AgentCandidatesCandidate_import_requestsPresetsPresetIdIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/candidates/candidate_import_requests/new/$encryptId/': {
      id: '/agent/candidates/candidate_import_requests/new/$encryptId/'
      path: '/candidates/candidate_import_requests/new/$encryptId'
      fullPath: '/agent/candidates/candidate_import_requests/new/$encryptId'
      preLoaderRoute: typeof AgentCandidatesCandidate_import_requestsNewEncryptIdIndexRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agent/candidates/$candidateProfileId/interview_logs/new/': {
      id: '/agent/candidates/$candidateProfileId/interview_logs/new/'
      path: '/candidates/$candidateProfileId/interview_logs/new'
      fullPath: '/agent/candidates/$candidateProfileId/interview_logs/new'
      preLoaderRoute: typeof AgentCandidatesCandidateProfileIdInterview_logsNewIndexRouteImport
      parentRoute: typeof AgentRoute
    }
  }
}

interface AgentRouteChildren {
  AgentAnalysisRoute: typeof AgentAnalysisRoute
  AgentCandidate_tagsRoute: typeof AgentCandidate_tagsRoute
  AgentCompany_tagsRoute: typeof AgentCompany_tagsRoute
  AgentCustomizeRoute: typeof AgentCustomizeRoute
  AgentJob_post_tagsRoute: typeof AgentJob_post_tagsRoute
  AgentIndexRoute: typeof AgentIndexRoute
  AgentCompaniesNewRoute: typeof AgentCompaniesNewRoute
  AgentFormSettingsRoute: typeof AgentFormSettingsRoute
  AgentCandidate_mailsNewRoute: typeof AgentCandidate_mailsNewRoute
  AgentCandidate_mailsTemplatesNewRoute: typeof AgentCandidate_mailsTemplatesNewRoute
  AgentCandidate_mailsTemplatesTemplateIdEditRoute: typeof AgentCandidate_mailsTemplatesTemplateIdEditRoute
  AgentLinked_accountsIdRoute: typeof AgentLinked_accountsIdRoute
  AgentLinked_accountsSharedRoute: typeof AgentLinked_accountsSharedRoute
  AgentAllianceIndexRoute: typeof AgentAllianceIndexRoute
  AgentCandidate_mailsIndexRoute: typeof AgentCandidate_mailsIndexRoute
  AgentCandidatesIndexRoute: typeof AgentCandidatesIndexRoute
  AgentCompaniesIndexRoute: typeof AgentCompaniesIndexRoute
  AgentExport_requestsIndexRoute: typeof AgentExport_requestsIndexRoute
  AgentFormIndexRoute: typeof AgentFormIndexRoute
  AgentJob_change_processesIndexRoute: typeof AgentJob_change_processesIndexRoute
  AgentLinked_accountsIndexRoute: typeof AgentLinked_accountsIndexRoute
  AgentProfitsIndexRoute: typeof AgentProfitsIndexRoute
  AgentProvided_job_post_listsIndexRoute: typeof AgentProvided_job_post_listsIndexRoute
  AgentProvided_job_postsIndexRoute: typeof AgentProvided_job_postsIndexRoute
  AgentSettingsIndexRoute: typeof AgentSettingsIndexRoute
  AgentShared_job_postsIndexRoute: typeof AgentShared_job_postsIndexRoute
  AgentLinked_accountsNewSourceTypeRoute: typeof AgentLinked_accountsNewSourceTypeRoute
  AgentCandidatesCandidateProfileIdIndexRoute: typeof AgentCandidatesCandidateProfileIdIndexRoute
  AgentCandidatesNewIndexRoute: typeof AgentCandidatesNewIndexRoute
  AgentCompaniesCompaniesIdIndexRoute: typeof AgentCompaniesCompaniesIdIndexRoute
  AgentLinked_accountsNewIndexRoute: typeof AgentLinked_accountsNewIndexRoute
  AgentProvided_job_post_listsListIdIndexRoute: typeof AgentProvided_job_post_listsListIdIndexRoute
  AgentProvided_job_postsProvidedJobPostsIdIndexRoute: typeof AgentProvided_job_postsProvidedJobPostsIdIndexRoute
  AgentTrialTutorialIndexRoute: typeof AgentTrialTutorialIndexRoute
  AgentLinked_accountsNewGroupGroupKeyRoute: typeof AgentLinked_accountsNewGroupGroupKeyRoute
  AgentProvided_job_postsNewPdfIdRoute: typeof AgentProvided_job_postsNewPdfIdRoute
  AgentProvided_job_postsNewTextIdRoute: typeof AgentProvided_job_postsNewTextIdRoute
  AgentAllianceApplicationsApplicationIdIndexRoute: typeof AgentAllianceApplicationsApplicationIdIndexRoute
  AgentCandidatesCandidate_import_requestsNewIndexRoute: typeof AgentCandidatesCandidate_import_requestsNewIndexRoute
  AgentProvided_job_postsProvidedJobPostsIdEditIndexRoute: typeof AgentProvided_job_postsProvidedJobPostsIdEditIndexRoute
  AgentProvided_job_postsNewCsvIndexRoute: typeof AgentProvided_job_postsNewCsvIndexRoute
  AgentProvided_job_postsNewManualIndexRoute: typeof AgentProvided_job_postsNewManualIndexRoute
  AgentProvided_job_postsNewPdfIndexRoute: typeof AgentProvided_job_postsNewPdfIndexRoute
  AgentProvided_job_postsNewTextIndexRoute: typeof AgentProvided_job_postsNewTextIndexRoute
  AgentTrialAccountLinkIndexRoute: typeof AgentTrialAccountLinkIndexRoute
  AgentCandidatesCandidateProfileIdInterview_logsNewIndexRoute: typeof AgentCandidatesCandidateProfileIdInterview_logsNewIndexRoute
  AgentCandidatesCandidate_import_requestsNewEncryptIdIndexRoute: typeof AgentCandidatesCandidate_import_requestsNewEncryptIdIndexRoute
  AgentCandidatesCandidate_import_requestsPresetsPresetIdIndexRoute: typeof AgentCandidatesCandidate_import_requestsPresetsPresetIdIndexRoute
  AgentProvided_job_postsNewCsvJobPostImportRequestIdIndexRoute: typeof AgentProvided_job_postsNewCsvJobPostImportRequestIdIndexRoute
}

const AgentRouteChildren: AgentRouteChildren = {
  AgentAnalysisRoute: AgentAnalysisRoute,
  AgentCandidate_tagsRoute: AgentCandidate_tagsRoute,
  AgentCompany_tagsRoute: AgentCompany_tagsRoute,
  AgentCustomizeRoute: AgentCustomizeRoute,
  AgentJob_post_tagsRoute: AgentJob_post_tagsRoute,
  AgentIndexRoute: AgentIndexRoute,
  AgentCompaniesNewRoute: AgentCompaniesNewRoute,
  AgentFormSettingsRoute: AgentFormSettingsRoute,
  AgentCandidate_mailsNewRoute: AgentCandidate_mailsNewRoute,
  AgentCandidate_mailsTemplatesNewRoute: AgentCandidate_mailsTemplatesNewRoute,
  AgentCandidate_mailsTemplatesTemplateIdEditRoute: AgentCandidate_mailsTemplatesTemplateIdEditRoute,
  AgentLinked_accountsIdRoute: AgentLinked_accountsIdRoute,
  AgentLinked_accountsSharedRoute: AgentLinked_accountsSharedRoute,
  AgentAllianceIndexRoute: AgentAllianceIndexRoute,
  AgentCandidate_mailsIndexRoute: AgentCandidate_mailsIndexRoute,
  AgentCandidatesIndexRoute: AgentCandidatesIndexRoute,
  AgentCompaniesIndexRoute: AgentCompaniesIndexRoute,
  AgentExport_requestsIndexRoute: AgentExport_requestsIndexRoute,
  AgentFormIndexRoute: AgentFormIndexRoute,
  AgentJob_change_processesIndexRoute: AgentJob_change_processesIndexRoute,
  AgentLinked_accountsIndexRoute: AgentLinked_accountsIndexRoute,
  AgentProfitsIndexRoute: AgentProfitsIndexRoute,
  AgentProvided_job_post_listsIndexRoute:
    AgentProvided_job_post_listsIndexRoute,
  AgentProvided_job_postsIndexRoute: AgentProvided_job_postsIndexRoute,
  AgentSettingsIndexRoute: AgentSettingsIndexRoute,
  AgentShared_job_postsIndexRoute: AgentShared_job_postsIndexRoute,
  AgentLinked_accountsNewSourceTypeRoute:
    AgentLinked_accountsNewSourceTypeRoute,
  AgentCandidatesCandidateProfileIdIndexRoute:
    AgentCandidatesCandidateProfileIdIndexRoute,
  AgentCandidatesNewIndexRoute: AgentCandidatesNewIndexRoute,
  AgentCompaniesCompaniesIdIndexRoute: AgentCompaniesCompaniesIdIndexRoute,
  AgentLinked_accountsNewIndexRoute: AgentLinked_accountsNewIndexRoute,
  AgentProvided_job_post_listsListIdIndexRoute:
    AgentProvided_job_post_listsListIdIndexRoute,
  AgentProvided_job_postsProvidedJobPostsIdIndexRoute:
    AgentProvided_job_postsProvidedJobPostsIdIndexRoute,
  AgentTrialTutorialIndexRoute: AgentTrialTutorialIndexRoute,
  AgentLinked_accountsNewGroupGroupKeyRoute:
    AgentLinked_accountsNewGroupGroupKeyRoute,
  AgentProvided_job_postsNewPdfIdRoute: AgentProvided_job_postsNewPdfIdRoute,
  AgentProvided_job_postsNewTextIdRoute: AgentProvided_job_postsNewTextIdRoute,
  AgentAllianceApplicationsApplicationIdIndexRoute:
    AgentAllianceApplicationsApplicationIdIndexRoute,
  AgentCandidatesCandidate_import_requestsNewIndexRoute:
    AgentCandidatesCandidate_import_requestsNewIndexRoute,
  AgentProvided_job_postsProvidedJobPostsIdEditIndexRoute:
    AgentProvided_job_postsProvidedJobPostsIdEditIndexRoute,
  AgentProvided_job_postsNewCsvIndexRoute:
    AgentProvided_job_postsNewCsvIndexRoute,
  AgentProvided_job_postsNewManualIndexRoute:
    AgentProvided_job_postsNewManualIndexRoute,
  AgentProvided_job_postsNewPdfIndexRoute:
    AgentProvided_job_postsNewPdfIndexRoute,
  AgentProvided_job_postsNewTextIndexRoute:
    AgentProvided_job_postsNewTextIndexRoute,
  AgentTrialAccountLinkIndexRoute: AgentTrialAccountLinkIndexRoute,
  AgentCandidatesCandidateProfileIdInterview_logsNewIndexRoute:
    AgentCandidatesCandidateProfileIdInterview_logsNewIndexRoute,
  AgentCandidatesCandidate_import_requestsNewEncryptIdIndexRoute:
    AgentCandidatesCandidate_import_requestsNewEncryptIdIndexRoute,
  AgentCandidatesCandidate_import_requestsPresetsPresetIdIndexRoute:
    AgentCandidatesCandidate_import_requestsPresetsPresetIdIndexRoute,
  AgentProvided_job_postsNewCsvJobPostImportRequestIdIndexRoute:
    AgentProvided_job_postsNewCsvJobPostImportRequestIdIndexRoute,
}

const AgentRouteWithChildren = AgentRoute._addFileChildren(AgentRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AdminRoute: AdminRoute,
  AgentRoute: AgentRouteWithChildren,
  AccountLoginRoute: AccountLoginRoute,
  AccountTrialRoute: AccountTrialRoute,
  AccountInviteTokenRoute: AccountInviteTokenRoute,
  AccountPasswordSettingRoute: AccountPasswordSettingRoute,
  AccountSetupIdRoute: AccountSetupIdRoute,
  AccountPasswordResetTokenRoute: AccountPasswordResetTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
